import { Chain } from '@emberswap/emberswap-sdk2/dist/entities'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'

import { classNames } from '../../../functions'
import { useBlockNumber, useSessionChainId } from '../../../state/application/hooks'

/**
 * @return {JSX.Element} with Block Number
 */
export default function Polling() {
  const [chainId] = useSessionChainId()
  const blockNumber = useBlockNumber()
  const [isMounted, setIsMounted] = useState(true)

  useEffect(() => {
    const timer1 = setTimeout(() => setIsMounted(true), 1000)
    return () => {
      setIsMounted(false)
      clearTimeout(timer1)
    }
  }, [blockNumber])

  return (
    <Link
      href={Chain.fromChainId(chainId)?.blockExplorers?.default.url + '/block/' + blockNumber || ''}
      target="_blank"
      rel="noreferrer"
      className={classNames(
        `${!isMounted ? 'text-pollingactive' : 'text-polling'}`,
        'hover:text-pollingactive relative flex items-center px-2 font-thin text-xxs tracking-default landscape:ml-5 lg:landscape:ml-0'
      )}
    >
      <div className={`flex items-center space-x-1`}>
        <svg
          className={`h-6 w-6 ${!isMounted ? 'animate-spin' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.5"
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          />
        </svg>
        <div>{blockNumber}</div>
      </div>
    </Link>
  )
}
